/**
 * OrderForm bileşeninde kullanılan yardımcı fonksiyonlar ve stiller
 */

// Sayısal alanlarda negatif işareti ve 'e' karakterini engelle
export const handleNumericKeyDown = (e) => {
  if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
    e.preventDefault();
  }
};

// react-select için stil özelleştirmesi
export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    padding: '0px 4px',
    minHeight: '42px',
    border: state.isFocused ? '1px solid #29472d' : '1px solid #ddd',
    boxShadow: 'none',
    borderRadius: '6px',
    '&:hover': {
      border: state.isFocused ? '1px solid #29472d' : '1px solid #cbd5e1'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '42px',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px',
    padding: '0px',
    'input:focus': {
      boxShadow: 'none !important'
    }
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '6px 12px',
    backgroundColor: state.isSelected ? '#29472d' : state.isFocused ? '#fff5f0' : 'white',
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#333',
  })
};
